import { useState, useEffect, useRef } from 'react'
import { Link, useNavigate } from 'react-router-dom'
// ------ Services ------ //
import * as exhibitorLeadCaptureService from '../../services/exhibitorLeadCaptureService'
import * as webBridgeService from '../../services/webBridgeService'
// ------ Styles ------ //
import styles from './Header.module.css'

const SuperAdminHeader = ({ user }) => {
    const [formData, setFormData] = useState(
        {
            clientName: null,
            client: {},
            leadCapture: {},
            leadCaptureName: null,
            exhibitor: {},
            exhibitorId: null,
        }
    )
    // State    
    const [clientOptions, setClientOptions] = useState([])
    const [leadCaptureOptions, setLeadCaptureOptions] = useState([])
    const [exhibitorOptions, setExhibitorOptions] = useState([])
    const [exhibitorLeadCaptureInfo, setExhibitorLeadCaptureInfo] = useState({})

    const isMounted = useRef(false)
    const fetchExhibitors = async () => {
        if (formData.clientName && formData.client && formData.leadCapture && formData.leadCaptureName) {
            try {
                const exhibitors = await webBridgeService.fetchExhibitorsByLeadCaptureId(formData.leadCapture.id);
                if (exhibitors && exhibitors.length > 0) {
                    setExhibitorOptions(exhibitors);
                }
                else {
                    setExhibitorOptions([]);
                }
            } catch /*(err)*/ {
                setExhibitorOptions([]);
            }

        }

    }
    const fetchLeadCaptures = async () => {
        if (formData.clientName && formData.client) {
            try {
                const leadCaptures = await webBridgeService.fetchEventsByClient(formData.client.clientId, false);
                if (leadCaptures && leadCaptures.length > 0) {
                    setLeadCaptureOptions(leadCaptures);
                   
                }
                else {
                    setLeadCaptureOptions([]);
                }
            } catch /*(err)*/ {
                setLeadCaptureOptions([]);
            }
            
        }
    }

    const fetchClients = async () => {
        const clients = await webBridgeService.fetchClientsWithLeadCapture();
        setClientOptions(clients);
    }

    useEffect(() => {
        // don't store on initial render
        if (formData.clientName && formData.client && isMounted.current && formData.leadCapture && formData.leadCaptureName
            && formData.exhibitor && formData.exhibitor.id) {
            // save to localstorage
            exhibitorLeadCaptureService.setExhibitorLeadCapture({
                clientId: formData.client.clientId,
                clientName: formData.client.clientName,
                leadCaptureId: formData.leadCapture.id,
                leadCaptureName: formData.leadCapture.overwriteName,
                exhibitorId: formData.exhibitor.id
            })
        }
        else {
            // pull on initial render
            // meant to prevent blank overwrites
            isMounted.current = true;
        }
    }, [exhibitorLeadCaptureInfo])

    useEffect(() => {
        // pull exhibitors, if client and leadcapture is populated and selected
        if (formData.leadCapture && formData.leadCaptureName) {
            setExhibitorOptions([]);
            fetchExhibitors();
        }
    }, [formData.leadCaptureName])

    useEffect(() => {
        // pull events and lead capture events, if clients is populated and selected
        if (formData.clientName && formData.client) {
            setLeadCaptureOptions([]);
            fetchLeadCaptures();
        }
    }, [formData.clientName])

    useEffect(() => {
        if (clientOptions && clientOptions.length > 0 && exhibitorLeadCaptureInfo && exhibitorLeadCaptureInfo.clientName) {
            setClientInfo(exhibitorLeadCaptureInfo.clientName)
        }
    }, [clientOptions])
    
    useEffect(() => {
        //set selections to the saved values
        if (leadCaptureOptions && leadCaptureOptions.length > 0 && exhibitorLeadCaptureInfo && exhibitorLeadCaptureInfo.leadCaptureName) {
            setLeadCaptureInfo(exhibitorLeadCaptureInfo.leadCaptureName)
        }
        else if (leadCaptureOptions && leadCaptureOptions.length > 0) {
            // default to first, should be "latest"
            setLeadCaptureInfo(leadCaptureOptions[0].overwriteName)
        }
    }, [leadCaptureOptions])

    useEffect(() => {
        //set selections to the saved values
        if (exhibitorOptions && exhibitorOptions.length > 0 && exhibitorLeadCaptureInfo && exhibitorLeadCaptureInfo.leadCaptureName
            && exhibitorLeadCaptureInfo.exhibitorId) {
            setExhibitorInfo(exhibitorLeadCaptureInfo.exhibitorId)
        }
    }, [exhibitorOptions])

    useEffect(() => {
        // check if entry is stored
        // store into local object
        let localclientevent = exhibitorLeadCaptureService.getExhibitorLeadCapture()
        if (localclientevent) {
            setExhibitorLeadCaptureInfo(localclientevent)
        }
        // pull clients
        fetchClients();
    }, [])

    const clearLeadCapture = () => {
        formData.leadCapture = null;
        formData.leadCaptureName = null;
    }
    const clearExhibitor = () => {
        formData.exhibitor = null;
        formData.exhibitorId = null;
    }

    const setClientInfo = (clientname) => {
        let foundClient = clientOptions.find((item) => item.clientName === clientname);
        if (foundClient) {
            formData.client = foundClient;
            formData.clientName = foundClient.clientName;
            //updating React state you must create shallow copies of all state (and nested state) that you are updating.
            setFormData({
                ...formData,
                ['clientName']: foundClient.clientName,
                ['client']: foundClient,
            })
        }
        else {
            formData.clientName = null;
            formData.client = {};
            setFormData({
                ...formData,
                ['clientName']: null,
                ['client']: {},
            })
        }
    }


    const setLeadCaptureInfo = (leadCaptureName) => { 
        let foundLeadCapture = leadCaptureOptions.find((item) => item.overwriteName === leadCaptureName);
        if (foundLeadCapture) {
            formData.leadCapture = foundLeadCapture;
            formData.leadCaptureName = foundLeadCapture.overwriteName;
            //updating React state you must create shallow copies of all state (and nested state) that you are updating.
            setFormData({
                ...formData,                                         
                ['leadCaptureName']: foundLeadCapture.overwriteName, 
                ['leadCapture']: foundLeadCapture,
            })
        }
        else {
            formData.leadCaptureName = null;
            formData.leadCapture = {};
            setFormData({
                ...formData,
                ['leadCaptureName']: null,
                ['leadCapture']: {},
            })
        }

    }
    const setExhibitorInfo = (exhibitorId) => {
        let foundExhibitor = exhibitorOptions.find((item) => item.id === exhibitorId);
        if (foundExhibitor) {
            formData.exhibitor = foundExhibitor;
            formData.exhibitorId = foundExhibitor.id;
            //updating React state you must create shallow copies of all state (and nested state) that you are updating.
            setFormData({
                ...formData,
                ['exhibitorId']: foundExhibitor.id,
                ['exhibitor']: foundExhibitor,
            })
        }
        else {
            formData.exhibitorId = null;
            formData.exhibitor = {};
            setFormData({
                ...formData,
                ['exhibitorId']: null,
                ['exhibitor']: {},
            })
        }

    }

    const trimEventName = name => { 
        const charCutoff = 50
        if (!name || name.length <= charCutoff) return name
        const trimmed = name.substring(0, charCutoff) + "..."
        return trimmed
    }
    const handleChangeClient = (e) => {
        if (e.target.type === 'select-one') {
            setClientInfo(e.target.value)
            // clear old events
            clearLeadCapture();// proper clearing of child state
            if (formData.clientName && formData.client) {
                fetchLeadCaptures();
            }
        }
        else {
            setFormData({
                ...formData,
                [e.target.name]: e.target.value,
            })
        }
    }
    const handleChangeLeadCapture = (e) => {

        if (e.target.type === 'select-one') {
            setLeadCaptureInfo(e.target.value)
            // clear old exhibitors
            clearExhibitor();
            if (formData.leadCaptureName && formData.lead) {
                fetchExhibitors();
            }
        }
        else {
            setFormData({
                ...formData,
                [e.target.name]: e.target.value,
            })
        }
    }
    const handleChangeExhibitor = (e) => {

        if (e.target.type === 'select-one') {
            let divId = e.currentTarget.value 
            setExhibitorInfo(divId)
            // save to localstorage
            exhibitorLeadCaptureService.setExhibitorLeadCapture({
                clientId: formData.client.clientId,
                clientName: formData.client.clientName,
                leadCaptureId: formData.leadCapture.id,
                leadCaptureName: formData.leadCapture.overwriteName,
                exhibitorId: formData.exhibitor.id,
            })
        }
        else {
            setFormData({
                ...formData,
                [e.target.name]: e.target.value,
            })
        }
    }

    return (
        <div>

            <div className={styles.headerContainer}>
                <div className={styles.leftPane}>
                    <b>Select Client and Lead Capture:</b>
                </div>
                <div className={styles.middlePane}>
                    Client: <br />
                    {
                        clientOptions && clientOptions.length > 0 ?
                            <select
                                name="clientName"
                                value={formData.clientName}
                                onChange={handleChangeClient}
                                key={formData.clientName}
                            >
                                <option disabled={true} value="" selected="selected">
                                    -- Select an option --
                                </option>
                                {
                                    clientOptions.map((ci, idx) => (
                                        <option key={idx}>{ci.clientName}</option>
                                    ))
                                }
                            </select>
                            :
                            <></>
                    }
                </div>

                <div className={styles.middlePane}>
                    Lead Capture:
                    <br />
                    {
                        formData.clientName && formData.client && leadCaptureOptions && leadCaptureOptions.length > 0 ?
                            <select
                                name="leadCaptureName"
                                value={formData.leadCaptureName}
                                onChange={handleChangeLeadCapture}
                                key={formData.leadCaptureName}
                            >
                                <option disabled={true} value="" selected="selected">
                                    -- Select an option --
                                </option>
                                {
                                    leadCaptureOptions.map((ci, idx) => (
                                        <option key={idx}>{trimEventName(ci.overwriteName)}</option>
                                    ))
                                }
                            </select>
                            :
                            <>
                                <div>
                                    <label>No Lead Captures found (
                                        <Link to={`/LeadCaptureList`}>Lead Capture List...)</Link>
                                    </label>
                                </div>
                            </>
                    }
                </div>
                <div className={styles.middlePane}>
                    Exhibitor:
                    <br />
                    {
                        formData.clientName && formData.client && formData.leadCaptureName && formData.leadCapture && exhibitorOptions && exhibitorOptions.length > 0 ?
                            <select
                                name="exhibitorId"
                                value={formData.exhibitorId}
                                onChange={handleChangeExhibitor}
                                key={formData.exhibitorId}
                            >
                                <option disabled={true} value="" selected="selected">
                                    -- Select an option --
                                </option>
                                {
                                    exhibitorOptions.map((ci, idx) => (
                                        <option key={idx} value={ci.id}>{trimEventName(ci.firstName + ' ' + ci.lastName + '(' + ci.organization + ')')}</option>
                                    ))
                                }
                            </select>
                            :
                            <>
                                <div>
                                    No Exhibitors found!
                                </div>
                            </>
                    }
                </div>

            </div>
        </div>
    );
}

export default SuperAdminHeader;
